<template>
    <div class="copy-presenter">
        <h2 class="copy-presenter__title">
            {{ title }}
        </h2>
        <section class="copy-presenter__copy">
            <component :is="nestedComponent" />
        </section>
        <div v-if="showButtons"
             class="copy-presenter__buttons --modal-buttons">
            <hh-btn class="copy-presenter__button"
                    text="OK"
                    @click="onOkClick" />
        </div>
    </div>
</template>

<script>

export default {

    name: 'CopyPresenterModal',

    props: {

        /**
         * @type {{ title: string, hideButtons: boolean }}
         */
        info: {
            type: Object,
            required: true,
        },

        /**
         * @type {Object|string}
         */
        nestedComponent: {
            type: Object,
            required: true,
        },
    },

    computed: {

        /**
         * @returns {boolean}
         */
        showButtons() {
            return !this.info.hideButtons
        },

        /**
         * @returns {string}
         */
        title() {
            return this.info.title ? this.info.title : ''
        },
    },

    methods: {

        /**
         * Event method.
         */
        onOkClick() {
            this.$eventbus.$emit(this.$appevents.hideModal)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.copy-presenter {
    padding-bottom: $cta-tile-breakout-single-height;

    @include bp-min-mid {
        padding-bottom: 0;
    }

    @include element('buttons') {
        padding-top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    @include element('button') {
        min-width: 120px;
    }
}

</style>
